export const BusinessProfileConstants = {
  UPDATE_BUSINESS_PROFILE_SUCCESS: '  BUSINESSPROFILE/UPDATE_BUSINESS_PROFILE_SUCCESS',

  GET_LINKED_ADDRESS_LIST_REQUEST: 'BUSINESSPROFILE/GET_LINKED_ADDRESS_LIST_REQUEST',
  GET_LINKED_ADDRESS_LIST_SUCCESS: 'BUSINESSPROFILE/GET_LINKED_ADDRESS_LIST_SUCCESS',
  GET_LINKED_ADDRESS_LIST_FAILED: 'BUSINESSPROFILE/GET_LINKED_ADDRESS_LIST_FAILED',

  GET_LINKED_PROFILE_LIST_REQUEST: 'PROFILE/GET_LINKED_PROFILE_LIST_REQUEST',
  GET_LINKED_PROFILE_LIST_SUCCESS: 'PROFILE/GET_LINKED_PROFILE_LIST_SUCCESS',
  GET_LINKED_PROFILE_LIST_FAILED: 'PROFILE/GET_LINKED_PROFILE_LIST_FAILED'
};
